import React from 'react'
import { Toaster } from 'sonner'
import { useTheme } from '../../contexts/ThemeContext'

const ThemedToaster = () => {
  const { theme } = useTheme()

  return (
    <Toaster
      position="bottom-left"
      expand={true}
      richColors={false}
      closeButton={true}
      theme={theme}
      toastOptions={{
        style: {
          background: 'var(--toaster-background)',
          color: 'var(--toaster-foreground)',
          border: `1px solid hsl(var(--border))`,
          maxWidth: '500px',
          width: '100%'
        },
        className: 'my-toast-class',
      }}
      style={{ zIndex: 999999999 }}
    />
  )
}

export default ThemedToaster
